/**
 * Empresa con la que se trabaja (multiempresa). En producción sale del subdominio
 * (prado.ruttiaapp.com); en local o en una dirección sin subdominio, del código que la persona escribe
 * al ingresar, que se recuerda en este navegador. El API la recibe en el encabezado X-Company.
 */
const KEY = 'ruttia.company';
export const COMPANY_CODE = /^[a-z0-9]{3,20}$/;
const RESERVED = ['www', 'app', 'api', 'panel', 'portal', 'admin'];
const baseDomain = () => (process.env.REACT_APP_BASE_DOMAIN || 'ruttiaapp.com').toLowerCase();

/** Código desde el subdominio, o null si la dirección no es de una empresa. */
export const companyFromHost = (hostname: string = window.location.hostname): string | null => {
  const host = hostname.toLowerCase();
  const base = baseDomain();
  if (!host.endsWith(`.${base}`)) return null;
  const sub = host.slice(0, -(base.length + 1));
  return COMPANY_CODE.test(sub) && !RESERVED.includes(sub) ? sub : null;
};

export const getCompanyCode = (): string | null => {
  const fromHost = companyFromHost();
  if (fromHost) return fromHost;
  try {
    const saved = window.localStorage.getItem(KEY);
    return saved && COMPANY_CODE.test(saved) ? saved : null;
  } catch {
    return null;
  }
};

export const setCompanyCode = (code: string) => {
  try {
    window.localStorage.setItem(KEY, code);
  } catch {
    /* sin almacenamiento: se pedirá de nuevo */
  }
};

export const clearCompanyCode = () => {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* nada que borrar */
  }
};

/** Dirección del registro de empresas (portal). */
export const signupUrl = () => `${(process.env.REACT_APP_PORTAL_URL || 'https://portal.ruttiaapp.com').replace(/\/$/, '')}/signup`;
